import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { computed } from 'vue';

import { VideoFieldParams } from '../../../declarations/fields';
import { videoEmbedifier } from '../../../service/fields/fields';
import { BaseFieldProps } from '../composables/useBaseFieldProps';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'VideoField' },
  __name: 'Video',
  props: {
    label: { default: '' },
    showHistory: { type: Boolean },
    history: {},
    params: {}
  },
  setup(__props: any) {


const props = __props;

const videoSrc = computed(() => {
  if (props.params.link) {
    return videoEmbedifier(props.params.link);
  }
  return '';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("iframe", {
    width: "560",
    height: "315",
    src: videoSrc.value,
    title: "Video player",
    frameborder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
    allowfullscreen: ""
  }, null, 8, _hoisted_1))
}
}

})